import { render, staticRenderFns } from "./DialogTemplate.vue?vue&type=template&id=53fbb778&scoped=true&"
import script from "./DialogTemplate.vue?vue&type=script&lang=js&"
export * from "./DialogTemplate.vue?vue&type=script&lang=js&"
import style0 from "./DialogTemplate.vue?vue&type=style&index=0&id=53fbb778&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53fbb778",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/uu264406/workDirectory/shingaku/reset_html/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('53fbb778')) {
      api.createRecord('53fbb778', component.options)
    } else {
      api.reload('53fbb778', component.options)
    }
    module.hot.accept("./DialogTemplate.vue?vue&type=template&id=53fbb778&scoped=true&", function () {
      api.rerender('53fbb778', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/contents/components/common/common/Dialog/DialogTemplate.vue"
export default component.exports